import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home.jsx";
import Login from "./pages/Login.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import Test from "./pages/Test.jsx";
import { AppProvider } from "./AppContext.jsx";
import Clients from "./pages/Clients.jsx";
import WorkersPage from "./pages/WorkersPage.jsx";
import Register from "./components/Registration/Register.js";
import { QrForm } from "./components/Auth/QrForm.js";
import { AuthProvider } from "./AuthContext.js";
import Verify2fa from "./components/Auth/Verify2fa.js";

const App = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <AuthProvider>
                <Login />
              </AuthProvider>
            }
          />
          <Route
            path="/2fa-qr"
            element={
              <AuthProvider>
                <QrForm />
              </AuthProvider>
            }
          />
          <Route
            path="/verify-2fa"
            element={
              <AuthProvider>
                <Verify2fa />
              </AuthProvider>
            }
          />
          <Route path="/test" element={<Test />}></Route>
          <Route path="/clients" element={<Clients />}></Route>
          <Route path="/workers" element={<WorkersPage />}></Route>
          <Route path="/register/:token" element={<Register />}></Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
};

export default App;
